export default __webpack_public_path__ + "assets/f45f677564d42d8ed5830b998384c67b.woff2";